module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('section', {
    staticClass: "map"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "800px",
      "height": "450px"
    },
    attrs: {
      "center": _vm.getCenter,
      "zoom": 7,
      "map-type-id": "terrain"
    },
    on: {
      "rightclick": _vm.addMarker
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "domready": _vm.infoOpened,
      "content_changed": _vm.infoChanged,
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.getMarkers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "clickable": true,
        "position": m.position
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(m, index)
        }
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "delete"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.deleteMarker
    }
  }, [_vm._v("Delete")])], 1), _vm._v(" "), _c('div', {
    staticClass: "instruction"
  }, [_c('el-collapse', [_c('el-collapse-item', {
    attrs: {
      "title": "Instruction",
      "name": "1"
    }
  }, [_c('h3', [_vm._v("\r\n               1) Rightclick on map to marker some place. \r\n            ")]), _vm._v(" "), _c('h3', [_vm._v("\r\n               2) Click on input write something. \r\n            ")]), _vm._v(" "), _c('h3', [_vm._v("\r\n               3) Click Enter to save text in input.\r\n            ")]), _vm._v(" "), _c('h3', [_vm._v("\r\n              4) Delete marker on map need to click on marker and after click on button botom - delete.\r\n            ")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17b039f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/places/PlaceApp.vue
// module id = 278
// module chunks = 1